import React from 'react';
import PropTypes from 'prop-types';

import OutlookNotLinkedText from './OutlookNotLinkedText';
import OutlookLinkedText from './OutlookLinkedText';
import OutlookLinkedBeforeText from './OutlookLinkedBeforeText';

import ChooseCalendars from './ChooseCalendars';

export default function Outlook({ calendars }) {
  const linkBeforeInfoText = calendars.attributes.is_outlook_calendar_linked_before
    ? <OutlookLinkedBeforeText /> : <OutlookNotLinkedText />;

  const infoText = calendars.attributes.is_outlook_calendar_linked ? <OutlookLinkedText /> : linkBeforeInfoText;

  return (
    <div className="mt-4">
      <div className="mb-3 row">
        <div className="col-lg-6 mt-2">
          {infoText}
          {calendars.attributes.is_outlook_calendar_linked
          && <ChooseCalendars calendarType="outlook" calendars={calendars.attributes.outlook_calendars} />}
        </div>
        <div className="col-lg-6 mt-2">
          <div className="d-flex justify-content-end">
            <a
              // onClick={onDeleteAccount}
              className="btn btn-outline-primary"
              href={calendars.attributes.outlook_calendar_action}
            >
              MS Office 365
            </a>

          </div>
        </div>
      </div>
    </div>
  );
}

Outlook.propTypes = {
  calendars: PropTypes.object.isRequired,
};
